<template>
    <div v-if="content">
        <div class="project-conditions-content" v-html="content" />
    </div>
    <div v-else>An error occurred while generating document. Please contact support.</div>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {storeToRefs} from 'pinia';
    import {useRoute} from '#imports';
    import type {LanguageCode} from '@api';
    import {useProjectConditionsStore} from '~/stores/project-conditions.store';

    const route = useRoute();
    const projectConditionId = route.params.id as string;
    const projectConditionsStore = useProjectConditionsStore();

    // Get language from query params (e.g., ?language=FR)
    // Valid values: 'FR', 'EN', 'NL', 'DE', 'ES'
    // If not provided, store will default to 'EN' (English)
    const language = route.query.language as LanguageCode | undefined;

    await projectConditionsStore.fetchProjectCondition(projectConditionId, language);

    const {projectConditionContent} = storeToRefs(projectConditionsStore);

    const content = computed<string>(
        () =>
            projectConditionContent.value
                ?.replace(/&nbsp;/gi, ' ')
                .replace(/&#160;/g, ' ')
                .replace(/\u00A0/g, ' ') ?? '',
    );
</script>

<style lang="scss" scoped>
    @page {
        margin: 80px;
    }

    .project-conditions-content {
        span {
            overflow-wrap: normal;
            word-break: normal;
        }
    }
</style>
